<div id="station" style="display: none;">
    <label>Station Code : <input type="text" [formControl]="stationCode"></label><br/><br/>
    <label>Network Code : <input type="text" [formControl]="networkCode"></label><br/><br/>
    <label>Max Radius (deg.) * : <input type="text" [formControl]="maxRadius"></label><br/><br/>
    <!--label>Start Date : <input type="date" [formControl]="startDate"></label><br/><br/>
    <label>End Date : <input type="date" [formControl]="endDate"></label><br/><br/-->
    <button (click)="endQuery('station', false)">Close</button>
    <button style="margin: 0 5px; float: right;" (click)="endQuery('station', true)">Search</button><br/>
    <span style="font-size: 12px;color: grey;">* : required</span>
</div>

<div id="data" style="display: none;">
    <label>Station Code : <input type="text" [formControl]="stationCode"></label><br/><br/>
    <button (click)="endQuery('data', false)">Close</button>
    <button style="margin: 0 5px; float: right;" (click)="endQuery('data', true)">Search</button>
</div>

<div id="result" style="display: none;">
    <button (click)="endQuery('data', false)">Close</button>
</div>